export default __webpack_public_path__ + "static/media/aj9.18f5aa92.png";